import { createSlice } from '@reduxjs/toolkit';
const initialState = () => {
    return {
        reports:[],
        errors:[],
        reportCompanies:[],
        singlereport:[],
        latestReportDate: null,
    };
  };

const reportSlice = createSlice({
  name: 'report',
  initialState:initialState(),
  reducers: {
    setReports(state, action) {
      state.reports = action.payload;
    },
    setErrors(state, action) {
      state.errors = action.payload;
    },
    setReportCompanies(state, action) {
        state.reportCompanies = action.payload;
      },
    setSingleReport(state, action) {
      state.singlereport = action.payload;
    },
    setLatestReportDate(state, action) {
      state.latestReportDate = action.payload;
    },

  },
});

export const {
  setReports,
  setErrors,
  setReportCompanies,
  setSingleReport,
  setLatestReportDate,
  
} = reportSlice.actions;
export const report=reportSlice.reducer;